// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3vLOd","list":"PatternAutocomplete_list__2g6dv"};